import { FACEBOOK, INSTAGRAM, PHONECALL, WEBSITE, WHATSAPP } from "../constants/defaultSocialMedia";
import AdDetails from "../models/AdDetails";

export class SocialMediaContact {
    data = {};
    petData = {};
    objectDetails;

    constructor({data, petData = {}, objectDetails = AdDetails}) {
        this.data = data;
        this.petData = petData;
        this.objectDetails = objectDetails
    }

    buildLink() {
        if (this.data[this.objectDetails.default_media] === WHATSAPP && Object.keys(this.petData).length === 0) {
            return `https://api.whatsapp.com/send?phone=502${this.data[this.objectDetails.phone]}`;
        } else if (this.data[this.objectDetails.default_media] === WHATSAPP && Object.keys(this.petData).length !== 0) {
            return `https://api.whatsapp.com/send?phone=502${this.data[this.objectDetails.phone]}&text=Buen dia, me interesa adoptar esta mascota: https://adoptzi.com/mascotas/${this.petData['id']}/`;
        }

        if (this.data[this.objectDetails.default_media] === FACEBOOK) {
            return this.data[this.objectDetails.socialMedia].facebook;
        }

        if (this.data[this.objectDetails.default_media] === INSTAGRAM) {
            return this.data[this.objectDetails.socialMedia].instagram;
        }

        if (this.data[this.objectDetails.default_media] === WEBSITE) {
            return this.data[this.objectDetails.socialMedia].website;
        }

        if (this.data[this.objectDetails.default_media] === PHONECALL) {
            return `tel://+502${this.data[this.objectDetails.phone]}`;
        }
    }
}